module.exports = __webpack_public_path__ + "static/media/intro-video-sound.3e167189.m4a";